
import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().trim().required('Required.'),
  url: Yup.string().trim().matches(/^3hd\.us\/.{25}$/i, 'Invalid. (3hd.us/xxxxxxxxxxxxxxxxxxxxxxxxx)').required('Required.')
});
